import React, { useEffect, useState, useRef, useContext } from 'react';
import { Redirect, useHistory } from 'react-router-dom';
import { URLBunge } from "./Componentes/Config";
import { LogAcesso, ReactHtmlParser, MascaraCNPJ, AlertForm } from "./Componentes/Funcoes";
import CabecalhoPagina from "./Componentes/Cabecalho";
import Carregando from "./Componentes/Carregando";
import MenuPrinc from "./Componentes/MenuPrinc";
import Avatar from 'avataaars'
import ExitToAppIcon from '@material-ui/icons/ExitToApp';
import { useForm, Controller } from 'react-hook-form';
import InputMask from 'react-input-mask';

import {
  Clear,
  BackgroundImg,
  TitNoticias,
  ColunaRegras,
  BtEditarAvatar,
  DivItemNoticia,
  BgImgNoticia,
  DivBtsNoticiaNovidades,
  BtNoticiaNovidades,
  BtNoticiaNovidadesSelecionado,
  NomePerfil,
  ApelidoPerfil,
  EmailPerfil,
  BtAvatar,
  BtVoltar,
  BtSair,
  FormPesquisa,
  DescCampo,
  CampoFormBusca,
  TextoDescPesquisa,
  DoisCampos,
  CampoFormCadastro,
  FormCadastro,
  BotaoEnviarPesquisa,
  BtIcoBuscar,
  ModalEvento,
  BgModal,
  CaminhoPesquisas,
  ItemListaBusca,
  ClienteProdutoSelecionado,
  DivFilePesquisa,
  BotaoEntrar,
  BtAlterarSenha,
  ModalAlterarSenha,
  FormSenha
} from './Estilos'

import ImgBtSetaVoltar from "./Images/BtSeta.png";

function Perfil(props) {

  const history = useHistory();
  const [ Loading, setLoading ] = useState(true);
  const { register, handleSubmit, errors, control, setValue, getValues } = useForm();


  const [ NomeEvento, setNomeEvento ] = useState("Minha Bunge Vendas");
  const [ Token, setToken ] = useState(localStorage.getItem("c_token"));
  const [ NomeUsuario, setNomeUsuario ] = useState(localStorage.getItem("c_nome"));
  const [ EmailUsuario, setEmailUsuario ] = useState(localStorage.getItem("c_email"));
  const [ IdUsuario, setIdUsuario ] = useState(localStorage.getItem("id_tb_user"));
  const [ CPFUsuario, setCPFUsuario ] = useState(localStorage.getItem("c_cpf"));
  const [ Tipo, setTipo ] = useState(localStorage.getItem("c_tipo"));
  const [ Cargo, setCargo ] = useState(localStorage.getItem("c_cargo"));

  useEffect(() => {
    if (Token === null) {
        history.push({ pathname: '/', state: {} });
    } else {
        LogAcesso(Token, "Perfil")
    }
  }, []);

  const [Avatar_topType, setAvatar_topType] = useState(localStorage.getItem("c_avatar_topType"));
  const [Avatar_accessoriesType, setAvatar_accessoriesType] = useState(localStorage.getItem("c_avatar_accessoriesType"));
  const [Avatar_hatColor, setAvatar_hatColor] = useState(localStorage.getItem("c_avatar_hatColor"));
  const [Avatar_hairColor, setAvatar_hairColor] = useState(localStorage.getItem("c_avatar_hairColor"));
  const [Avatar_facialHairType, setAvatar_facialHairType] = useState(localStorage.getItem("c_avatar_facialHairType"));
  const [Avatar_facialHairColor, setAvatar_facialHairColor] = useState(localStorage.getItem("c_avatar_facialHairColor"));
  const [Avatar_clotheType, setAvatar_clotheType] = useState(localStorage.getItem("c_avatar_clotheType"));
  const [Avatar_clotheColor, setAvatar_clotheColor] = useState(localStorage.getItem("c_avatar_clotheColor"));
  const [Avatar_graphicType, setAvatar_graphicType] = useState(localStorage.getItem("c_avatar_graphicType"));
  const [Avatar_eyeType, setAvatar_eyeType] = useState(localStorage.getItem("c_avatar_eyeType"));
  const [Avatar_eyebrowType, setAvatar_eyebrowType] = useState(localStorage.getItem("c_avatar_eyebrowType"));
  const [Avatar_mouthType, setAvatar_mouthType] = useState(localStorage.getItem("c_avatar_mouthType"));
  const [Avatar_skinColor, setAvatar_skinColor] = useState(localStorage.getItem("c_avatar_skinColor"));

  const Estados = [
    { value: 'AC', label: 'Acre' },
    { value: 'AL', label: 'Alagoas' },
    { value: 'AP', label: 'Amapá' },
    { value: 'AM', label: 'Amazonas' },
    { value: 'BA', label: 'Bahia' },
    { value: 'CE', label: 'Ceará' },
    { value: 'DF', label: 'Distrito Federal' },
    { value: 'ES', label: 'Espírito Santo' },
    { value: 'GO', label: 'Goiás' },
    { value: 'MA', label: 'Maranhão' },
    { value: 'MT', label: 'Mato Grosso' },
    { value: 'MS', label: 'Mato Grosso do Sul' },
    { value: 'MG', label: 'Minas Gerais' },
    { value: 'PA', label: 'Pará' },
    { value: 'PB', label: 'Paraíba' },
    { value: 'PR', label: 'Paraná' },
    { value: 'PE', label: 'Pernambuco' },
    { value: 'PI', label: 'Piauí' },
    { value: 'RJ', label: 'Rio de Janeiro' },
    { value: 'RN', label: 'Rio Grande do Norte' },
    { value: 'RS', label: 'Rio Grande do Sul' },
    { value: 'RO', label: 'Rondônia' },
    { value: 'RR', label: 'Roraima' },
    { value: 'SC', label: 'Santa Catarina' },
    { value: 'SP', label: 'São Paulo' },
    { value: 'SE', label: 'Sergipe' },
    { value: 'TO', label: 'Tocantins' }
  ];












  const [TipoSelecionado, setTipoSelecionado] = useState(0);
  function MudaPesquisa(Tipo) {
      setTipoSelecionado(Tipo)
      if(Tipo === 0){
        LogAcesso(Token, "Perfil")
      } else {
        LogAcesso(Token, "Fale Conosco")
      }
  }




  function LogOut() {
    setLoading(true);

    setTimeout(() => {
      setNomeUsuario("");
      setEmailUsuario("");
      setIdUsuario("");
      setToken("");
      localStorage.removeItem("c_nome");
      localStorage.removeItem("c_email");
      localStorage.removeItem("c_id");
      localStorage.removeItem("c_token");
      history.push({ pathname: 'login', state: {} });      
    }, 500);    

  }




  const [ TextoAguarde, setTextoAguarde ] = useState(false);

  const onSubmit = async (data, e) => {

    if(data.c_celular == "" || data.c_celular == undefined){
      AlertForm('O campo CELULAR é de preenchimento obrigatório!');
      e.preventDefault();
      return false
    }

    if(data.c_cep == "" || data.c_cep == undefined){
      AlertForm('O campo CEP é de preenchimento obrigatório!');
      e.preventDefault();
      return false
    }

    if(data.c_endereco == "" || data.c_endereco == undefined){
      AlertForm('O campo ENDEREÇO é de preenchimento obrigatório!');
      e.preventDefault();
      return false
    }

    if(data.c_numero == "" || data.c_numero == undefined){
      AlertForm('O campo NÚMERO é de preenchimento obrigatório!');
      e.preventDefault();
      return false
    }

    if(data.c_bairro == "" || data.c_bairro == undefined){
      AlertForm('O campo BAIRRO é de preenchimento obrigatório!');
      e.preventDefault();
      return false
    }

    if(data.c_cidade == "" || data.c_cidade == undefined){
      AlertForm('O campo CIDADE é de preenchimento obrigatório!');
      e.preventDefault();
      return false
    }

    if(data.c_estado == 0){
      AlertForm('O campo ESTADO é de preenchimento obrigatório!');
      e.preventDefault();
      return false
    }

    setLoading(true);

    var DDDCel = data.c_celular
    .replace('-', '')
    .replace('(','')
    .replace(')','')
    .replace(' ','')
    .substr(0,2);

    var Celular = data.c_celular
    .replace('-', '')
    .replace('(','')
    .replace(')','')
    .replace(' ','')
    .substr(2,9);

    var DDDTel = data.c_telefone
    .replace('-', '')
    .replace('(','')
    .replace(')','')
    .replace(' ','')
    .substr(0,2)

    var Telefone = data.c_telefone
    .replace('-', '')
    .replace('(','')
    .replace(')','')
    .replace(' ','')
    .substr(2,8)

    // console.log(Telefone);

    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Authorization", "bearer " + Token);
    
    var raw = JSON.stringify({
      "apelido": data.c_apelido,
      "dddCelular": DDDCel,
      "celular": Celular,
      "dddFixo": DDDTel,
      "telefoneFixo": Telefone,
      "cep": data.c_cep,
      "rua": data.c_endereco,
      "numero": Number(data.c_numero),
      "complemento": data.c_complemento,
      "bairro": data.c_bairro,
      "cidade": data.c_cidade,
      "estado": data.c_estado
    });
    console.log(raw);


    var requestOptions = {
      method: 'POST',
      headers: myHeaders,
      body: raw,
      redirect: 'follow'
    };

    fetch(`${URLBunge}/api/Cliente/Altera`, requestOptions)
      .then(response => response.json())

      .then(result => {

      if(result.sucesso === true){
        // console.log(result);
        AlertForm("Dados atualizados com sucesso!");
        setLoading(false);
      } else {
        AlertForm(result.mensagem);
        setLoading(false);
      }

      })

      .catch(error => console.log('error', error));









  };



  const [ id_tb_user, set_id_tb_user ] = useState("");
  const [ c_nome, set_c_nome ] = useState("");
  const [ c_apelido, set_c_apelido ] = useState("");
  const [ c_email, set_c_email ] = useState("");
  const [ c_telefone, set_c_telefone ] = useState("");
  const [ c_celular, set_c_celular ] = useState("");
  const [ c_cpf, set_c_cpf ] = useState("");
  const [ c_cep, set_c_cep ] = useState("");
  const [ c_endereco, set_c_endereco ] = useState("");
  const [ c_numero, set_c_numero ] = useState("");
  const [ c_complemento, set_c_complemento ] = useState("");
  const [ c_cidade, set_c_cidade ] = useState("");
  const [ c_bairro, set_c_bairro ] = useState("");
  const [ c_estado, set_c_estado ] = useState("");
  const [ c_tipo, set_c_tipo ] = useState("");
  const [ c_cargo, set_c_cargo ] = useState("");

  const BuscaDadosUsuario = async () => {  
    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Authorization", "bearer " + Token);

    const ListarClienteDoc = await fetch(URLBunge + '/api/Cliente/ListarClienteDoc', {
      method: 'GET',
      headers: myHeaders,
      redirect: 'follow'
    });

    const resultListarClienteDoc = await ListarClienteDoc.json();
    // console.log(resultListarClienteDoc);

    if(resultListarClienteDoc.sucesso === true) {

      setLoading(false)

      localStorage.setItem("id_tb_user", resultListarClienteDoc.idCliente.toString());
      setValue('id_tb_user', resultListarClienteDoc.idCliente.toString());
      set_id_tb_user(resultListarClienteDoc.idCliente.toString());

      localStorage.setItem("c_nome", resultListarClienteDoc.nome);
      setValue('c_nome', resultListarClienteDoc.nome);
      set_c_nome(resultListarClienteDoc.nome);

      localStorage.setItem("c_apelido", resultListarClienteDoc.apelido);
      setValue('c_apelido', resultListarClienteDoc.apelido);
      set_c_apelido(resultListarClienteDoc.apelido);

      localStorage.setItem("c_email", resultListarClienteDoc.email);
      setValue('c_email', resultListarClienteDoc.email);
      set_c_email(resultListarClienteDoc.email);

      localStorage.setItem("c_telefone", resultListarClienteDoc.dddFixo+''+resultListarClienteDoc.telefoneFixo);
      setValue('c_telefone', resultListarClienteDoc.dddFixo+''+resultListarClienteDoc.telefoneFixo);
      set_c_telefone(resultListarClienteDoc.dddFixo+''+resultListarClienteDoc.telefoneFixo);

      localStorage.setItem("c_celular", resultListarClienteDoc.dddCelular+''+resultListarClienteDoc.celular);
      setValue('c_celular', resultListarClienteDoc.dddCelular+''+resultListarClienteDoc.celular);
      set_c_celular(resultListarClienteDoc.dddCelular+''+resultListarClienteDoc.celular);

      localStorage.setItem("c_cpf", resultListarClienteDoc.cpf);
      setValue('c_cpf', resultListarClienteDoc.cpf);
      set_c_cpf(resultListarClienteDoc.cpf);

      localStorage.setItem("c_cep", resultListarClienteDoc.cep);
      setValue('c_cep', resultListarClienteDoc.cep);
      set_c_cep(resultListarClienteDoc.cep);

      localStorage.setItem("c_endereco", resultListarClienteDoc.rua);
      setValue('c_endereco', resultListarClienteDoc.rua);
      set_c_endereco(resultListarClienteDoc.rua);

      localStorage.setItem("c_numero", resultListarClienteDoc.numero.toString());
      setValue('c_numero', resultListarClienteDoc.numero.toString());
      set_c_numero(resultListarClienteDoc.numero.toString());

      localStorage.setItem("c_complemento", resultListarClienteDoc.complemento);
      setValue('c_complemento', resultListarClienteDoc.complemento);
      set_c_complemento(resultListarClienteDoc.complemento);

      localStorage.setItem("c_bairro", resultListarClienteDoc.bairro);
      setValue('c_bairro', resultListarClienteDoc.bairro);
      set_c_bairro(resultListarClienteDoc.bairro);

      localStorage.setItem("c_cidade", resultListarClienteDoc.cidade);
      setValue('c_cidade', resultListarClienteDoc.cidade);
      set_c_cidade(resultListarClienteDoc.cidade);

      localStorage.setItem("c_estado", resultListarClienteDoc.estado);
      setValue('c_estado', resultListarClienteDoc.estado);
      set_c_estado(resultListarClienteDoc.estado);

      localStorage.setItem("c_tipo", resultListarClienteDoc.tipo.toString());
      setValue('c_tipo', resultListarClienteDoc.tipo.toString());
      set_c_tipo(resultListarClienteDoc.tipo.toString());

      localStorage.setItem("c_cargo", resultListarClienteDoc.cargo.toString());
      setValue('c_cargo', resultListarClienteDoc.cargo.toString());
      set_c_cargo(resultListarClienteDoc.cargo.toString());

    }

  };

  useEffect(() => {
    BuscaDadosUsuario();
  }, []);

  const TipoMensagem = [
    { value: 'Sugestões',  label: 'Sugestões' },
    { value: 'Dúvidas',  label: 'Dúvidas' },
    { value: 'Elogios',  label: 'Elogios' },
    { value: 'Reclamação',  label: 'Reclamação' },
    { value: 'Solicitação',  label: 'Solicitação' },
  ];


  const DDDCel = c_celular
  .replace('-', '')
  .replace('(','')
  .replace(')','')
  .replace(' ','')
  .substr(0,2);

  const Celular = c_celular
  .replace('-', '')
  .replace('(','')
  .replace(')','')
  .replace(' ','')
  .substr(2,9);

  const DDDTel = c_telefone
  .replace('-', '')
  .replace('(','')
  .replace(')','')
  .replace(' ','')
  .substr(0,2)

  const Telefone = c_telefone
  .replace('-', '')
  .replace('(','')
  .replace(')','')
  .replace(' ','')
  .substr(2,8)


  const EnviaFaleConosco = async (data, e) => {

    console.log(data);

    if(data.c_fale_tipo == 0){
      AlertForm('Tipo de mensagem é obrigatório!');
      e.preventDefault();
      return false
    }

    if(data.c_fale_mensagem == "" || data.c_fale_mensagem == undefined){
      AlertForm('Mensagem é obrigatório!');
      e.preventDefault();
      return false
    }

    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");

    var raw = JSON.stringify({
      "nome": c_nome,
      "cpf": c_cpf,
      "email": c_email,
      "ddd": DDDCel,
      "telefone": Celular,
      "tipo": data.c_fale_tipo,
      "mensagem": data.c_fale_mensagem,
      "ddd2": DDDTel,
      "telefone2": Telefone,
      "site": 2,
      "origem": 1072,
      "redirect": false
    });
    
    var requestOptions = {
      method: 'POST',
      headers: myHeaders,
      body: raw,
      redirect: 'follow'
    };
    
    fetch(`${URLBunge}/api/Contato/Insere`, requestOptions)
      .then(response => response.json())
      .then(result => {
        console.log(result);
        if(result.sucesso === false) {
          AlertForm( "Sua mensagem não foi enviada, tente novamente!" );
        } else {
          AlertForm( "Mensagem enviada com sucesso!" );
          setValue('c_fale_tipo', 0);
          setValue('c_fale_mensagem', '');
        }
      })
      .catch(error => console.log('error', error));
  };


  const EnviaAlteraSenha = async (data, e) => {

    // console.log(data);
    // console.log(CPFUsuario, c_email, data.c_senha);

    if(data.c_senha == "" || data.c_senha == undefined){
      AlertForm('Senha é obrigatório!');
      e.preventDefault();
      return false
    }

    if(data.c_confirmasenha == "" || data.c_confirmasenha == undefined){
      AlertForm('Confirmar nova senha é obrigatório!');
      e.preventDefault();
      return false
    }

    if(data.c_confirmasenha !== data.c_senha){
      AlertForm('Senhas não coincidem!');
      e.preventDefault();
      return false
    }

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "bearer " + Token);
    myHeaders.append("Content-Type", "application/json");

    var raw = JSON.stringify({
      "userId": CPFUsuario,
      "email": c_email,
      "userPassword": data.c_senha
    });

    var requestOptions = {
      method: 'POST',
      headers: myHeaders,
      body: raw,
      redirect: 'follow'
    };

    fetch(`${URLBunge}/api/GenLogin/NovaSenha`, requestOptions)
      .then(response => response.json())
      .then(result => {
        // console.log(result);

        if(result.sucesso) {
          AlertForm('Senha alterada com sucesso!');
          setMostraModalSenha(false);
          setValue('c_senha', '');
          setValue('c_confirmasenha', '');
        } else {
          AlertForm('Sua senha não foi alterada, tente novamente!');
          setValue('c_senha', '');
          setValue('c_confirmasenha', '');
        }

      })
      .catch(error => console.log('error', error));
    
  };







  const [TipoModalGranularIndireto, setTipoModalGranularIndireto] = useState(0);
  const [MetaPesquisas, setMetaPesquisas] = useState(0);
  const [PesquisasRealizadas, setPesquisasRealizadas] = useState(0);
  const [TextoQntPesquisas, setTextoQntPesquisas] = useState("");

  function AbreModalSenha () {
    setMostraModalSenha(true)
  }
  function FechaModalSenha () {
    setMostraModalSenha(false)
  }

  const [ MostraModalSenha, setMostraModalSenha ] = useState(false);
  const MostrarModalSenha = (props) => {
    const { register, handleSubmit, errors, control, setValue, getValues } = useForm();
    return <>
      <BgModal>
      <ModalAlterarSenha>
        <div className={'TextoEvento'}>
          <div className={'TituloEvento'}>Alterar senha</div>




          <FormSenha onSubmit={handleSubmit(EnviaAlteraSenha)}>
          
            <CampoFormCadastro>
              <Controller
                control={control}
                ref={register}
                id="c_senha"
                name="c_senha"
                type="password"
                placeholder={'Nova senha'}
                className="CampoForm CampoFormLogin"
                as={InputMask}
                mask=""
                defaultValue={''}
              />
            </CampoFormCadastro>
          
            <CampoFormCadastro>
              <Controller
                control={control}
                ref={register}
                id="c_confirmasenha"
                name="c_confirmasenha"
                type="password"
                placeholder={'Confirmar nova senha'}
                className="CampoForm CampoFormLogin"
                as={InputMask}
                mask=""
                defaultValue={''}
              />
            </CampoFormCadastro>

            <button className={'BtEnviaAlterarSenha'}>ALTERAR SENHA</button>

          </FormSenha>
          
          <a className={'BtFecharModal'} onClick={()=>FechaModalSenha()}>FECHAR</a>          
        </div>
      </ModalAlterarSenha>
      </BgModal>
    </>
  }



  return (
    <>  
        <CabecalhoPagina NomeEvento={NomeEvento} />
        {Loading === true ? <Carregando /> : null }

        <BackgroundImg Background={''} BackgroundMob={''} bgcolor={'#FFFFFF'}>
        {/* <BackgroundImg Background={BgRegras} BackgroundMob={BgRegras} bgcolor={'#3c647d'}> */}

        {MostraModalSenha === true ? <MostrarModalSenha /> : null }
            
            <ColunaRegras>
                <div className={'AreaColunaRegras'}>

                    <TitNoticias>Perfil</TitNoticias>

                    <div style={{display: 'flex', marginLeft: 'auto', marginRight: 'auto', maxWidth: 330}}>
                      <BtVoltar onClick={()=>history.push({ pathname: '/home', state: { } })} style={{marginLeft: 'auto', marginRight: 'auto'}}>
                        <img src={ImgBtSetaVoltar} /> <div>VOLTAR</div>
                      </BtVoltar>
                      <BtSair onClick={()=>LogOut()} style={{marginLeft: 'auto', marginRight: 'auto'}}>
                        <ExitToAppIcon /> <div>SAIR</div>
                      </BtSair>
                    </div>

                    <Clear />
                    <br/>

                    <DivBtsNoticiaNovidades>
                      {TipoSelecionado == 0 ?
                        <BtNoticiaNovidadesSelecionado>PERFIL</BtNoticiaNovidadesSelecionado>
                      :
                        <BtNoticiaNovidades onClick={()=>MudaPesquisa(0)}>PERFIL</BtNoticiaNovidades>
                      }
                      {TipoSelecionado == 1 ?
                        <BtNoticiaNovidadesSelecionado>FALE CONOSCO</BtNoticiaNovidadesSelecionado>
                      :
                        <BtNoticiaNovidades onClick={()=>MudaPesquisa(1)}>FALE CONOSCO</BtNoticiaNovidades>
                      }
                    </DivBtsNoticiaNovidades>

                    <Clear />


                    {TipoSelecionado == 0 ?
                      <>
                        <BtAvatar onClick={() => history.push({ pathname: 'perfilavatar', state: {} })}>
                          <Avatar
                            style = {{width: '220px', height: '220px'}}
                            avatarStyle = 'Transparent'
                            topType = {Avatar_topType}
                            accessoriesType = {Avatar_accessoriesType}
                            hatColor = {Avatar_hatColor}
                            hairColor = {Avatar_hairColor}
                            facialHairType = {Avatar_facialHairType}
                            facialHairColor = {Avatar_facialHairColor}
                            clotheType = {Avatar_clotheType}
                            clotheColor = {Avatar_clotheColor}
                            graphicType = {Avatar_graphicType}
                            eyeType = {Avatar_eyeType}
                            eyebrowType = {Avatar_eyebrowType}
                            mouthType = {Avatar_mouthType}
                            skinColor = {Avatar_skinColor}
                          />
                          <Clear />
                          <div className={'BtEditarAvatar'}>EDITAR AVATAR</div>
                        </BtAvatar>
                        <Clear />

                        <NomePerfil>{localStorage.getItem("c_nome")}</NomePerfil>
                        {localStorage.getItem("c_apelido") == "" ? null : <ApelidoPerfil>({localStorage.getItem("c_apelido")})</ApelidoPerfil>}
                        <EmailPerfil>{localStorage.getItem("c_email")}</EmailPerfil>


                        <br />

                        <FormCadastro onSubmit={handleSubmit(onSubmit)}>




                          <DoisCampos>

                            <CampoFormCadastro>
                              <Controller
                                control={control}
                                ref={register}
                                id="c_apelido"
                                name="c_apelido"
                                type="text"
                                placeholder={'Apelido'}
                                className="CampoForm CampoFormLogin"
                                as={InputMask}
                                mask=""
                                defaultValue={c_apelido}
                              />
                            </CampoFormCadastro>
                            <CampoFormCadastro>
                              <Controller
                                control={control}
                                ref={register}
                                id="c_telefone"
                                name="c_telefone"
                                type="text"
                                placeholder={'Telefone'}
                                className="CampoForm CampoFormLogin"
                                as={InputMask}
                                mask="(99) 9999-9999"
                                defaultValue={c_telefone}
                              />
                            </CampoFormCadastro>

                          </DoisCampos>


                          <DoisCampos>

                            <CampoFormCadastro>
                              <Controller
                                control={control}
                                ref={register}
                                id="c_celular"
                                name="c_celular"
                                type="text"
                                placeholder={'Celular'}
                                className="CampoForm CampoFormLogin"
                                as={InputMask}
                                mask="(99) 9999-99999"
                                defaultValue={c_celular}
                              />
                            </CampoFormCadastro>
                            <CampoFormCadastro>
                              <Controller
                                control={control}
                                ref={register}
                                id="c_cep"
                                name="c_cep"
                                type="text"
                                placeholder={'CEP'}
                                className="CampoForm CampoFormLogin"
                                as={InputMask}
                                mask="99999-999"
                                defaultValue={c_cep}
                              />
                            </CampoFormCadastro>
                          </DoisCampos>



                          <DoisCampos>

                            <CampoFormCadastro>
                              <Controller
                                control={control}
                                ref={register}
                                id="c_endereco"
                                name="c_endereco"
                                type="text"
                                placeholder={'Endereço'}
                                className="CampoForm CampoFormLogin"
                                as={InputMask}
                                mask=""
                                defaultValue={c_endereco}
                              />
                            </CampoFormCadastro>
                            <CampoFormCadastro>
                              <Controller
                                control={control}
                                ref={register}
                                id="c_numero"
                                name="c_numero"
                                type="text"
                                placeholder={'Número'}
                                className="CampoForm CampoFormLogin"
                                as={InputMask}
                                mask=""
                                defaultValue={c_numero}
                              />
                            </CampoFormCadastro>
                          </DoisCampos>




                          <DoisCampos>

                            <CampoFormCadastro>
                              <Controller
                                control={control}
                                ref={register}
                                id="c_complemento"
                                name="c_complemento"
                                type="text"
                                placeholder={'Complemento'}
                                className="CampoForm CampoFormLogin"
                                as={InputMask}
                                mask=""
                                defaultValue={c_complemento}
                              />
                            </CampoFormCadastro>

                            <CampoFormCadastro>
                              <Controller
                                control={control}
                                ref={register}
                                id="c_bairro"
                                name="c_bairro"
                                type="text"
                                placeholder={'Bairro'}
                                className="CampoForm CampoFormLogin"
                                as={InputMask}
                                mask=""
                                defaultValue={c_bairro}
                              />
                            </CampoFormCadastro>
                          </DoisCampos>





                          <DoisCampos>

                            <CampoFormCadastro>
                              <Controller
                                control={control}
                                ref={register}
                                id="c_cidade"
                                name="c_cidade"
                                type="text"
                                placeholder={'Cidade'}
                                className="CampoForm CampoFormLogin"
                                as={InputMask}
                                mask=""
                                defaultValue={c_cidade}
                              />
                            </CampoFormCadastro>

                            <CampoFormCadastro>
                              <select name={"c_estado"} id={"c_estado"} ref={register}>
                                <option value={0} disabled selected>Selecione</option>
                                {
                                  Estados.map((item, index) => {
                                    return <> <option value={item.value}>{item.label}</option> </>
                                  })
                                }
                              </select>
                            </CampoFormCadastro>
                          </DoisCampos>


                        
                          { TextoAguarde === false ?
                            <BotaoEnviarPesquisa type="submit">ALTERAR DADOS</BotaoEnviarPesquisa>
                          :
                            <BotaoEnviarPesquisa disabled>AGUARDE...</BotaoEnviarPesquisa>
                          }
                          <Clear />

                          <BtAlterarSenha onClick={()=>{AbreModalSenha()}}>ALTERAR SENHA</BtAlterarSenha>


                          </FormCadastro>



                        




                      </>

                    :

                    






                    <FormCadastro onSubmit={handleSubmit(EnviaFaleConosco)}>




                        <DoisCampos>

                          <CampoFormCadastro>
                            <Controller
                              control={control}
                              ref={register}
                              id="c_fale_nome"
                              name="c_fale_nome"
                              type="text"
                              placeholder={'Nome'}
                              className="CampoForm CampoFormLogin"
                              as={InputMask}
                              mask=""
                              defaultValue={c_nome}
                              disabled
                            />
                          </CampoFormCadastro>
                          <CampoFormCadastro>
                            <Controller
                              control={control}
                              ref={register}
                              id="c_fale_email"
                              name="c_fale_email"
                              type="text"
                              placeholder={'E-mail'}
                              className="CampoForm CampoFormLogin"
                              as={InputMask}
                              mask=""
                              defaultValue={c_email}
                              disabled
                            />
                          </CampoFormCadastro>

                        </DoisCampos>


                        <DoisCampos>
                          <CampoFormCadastro>
                            <Controller
                              control={control}
                              ref={register}
                              id="c_fale_telefone"
                              name="c_fale_telefone"
                              type="text"
                              placeholder={'Telefone'}
                              className="CampoForm CampoFormLogin"
                              as={InputMask}
                              mask="(99) 9999-9999"
                              defaultValue={c_telefone}
                              disabled
                            />
                          </CampoFormCadastro>

                          <CampoFormCadastro>
                            <Controller
                              control={control}
                              ref={register}
                              id="c_fale_celular"
                              name="c_fale_celular"
                              type="text"
                              placeholder={'Celular'}
                              className="CampoForm CampoFormLogin"
                              as={InputMask}
                              mask="(99) 9999-99999"
                              defaultValue={c_celular}
                              disabled
                            />
                          </CampoFormCadastro>
                        </DoisCampos>



                        <CampoFormCadastro style={{maxWidth: 600}}>
                          <select name={"c_fale_tipo"} id={"c_fale_tipo"} ref={register}>
                            <option value={0} disabled selected>Selecione</option>
                            {
                              TipoMensagem.map((item, index) => {
                                return <> <option value={item.value}>{item.label}</option> </>
                              })
                            }
                          </select>
                        </CampoFormCadastro>

                        <CampoFormCadastro style={{maxWidth: 600}}>
                          <textarea
                            control={control}
                            ref={register}
                            id="c_fale_mensagem"
                            name="c_fale_mensagem"
                            type="text"
                            placeholder={'Insira sua mensagem aqui'}
                            className="CampoForm CampoFormLogin"
                            as={InputMask}
                            defaultValue={''}
                          />
                        </CampoFormCadastro>




                      
                        { TextoAguarde === false ?
                          <BotaoEnviarPesquisa type="submit">ENVIAR</BotaoEnviarPesquisa>
                        :
                          <BotaoEnviarPesquisa disabled>AGUARDE...</BotaoEnviarPesquisa>
                        }
                        <Clear />

                        



                    </FormCadastro>








                    }
  


                </div>  
            </ColunaRegras>
            
            <MenuPrinc Pagina="Pesquisas" />
         </BackgroundImg>
    </>
  );

}

export default Perfil;
